<template lang="pug">
  b-modal#addTeam(
  ref="addTeam"
  :title="$t('ui.combine.add_team')"
  centered
  no-fade
  no-close-on-backdrop
  :busy="loading"
  @ok="done"
  @show="reset"
  @shown="shown")
    b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
      b-form-group(:label="$tc('ui.sports', 1)").mb-0
        SelectedSportDropDownList(
          ref="dataAdd_sportID"
          size="sm"
          required
          type="array"
          :dirty="$v.dataAdd_sportID.$dirty"
          :error="$v.dataAdd_sportID.$error"
          v-model.trim.lazy="$v.dataAdd_sportID.$model"
          :disabled="loading"
          :options="sportList"
        )
        ValidateResult(:value="$v.dataAdd_sportID" :name="$t('ui.sport')")
      b-form-group(:label="$t('ui.providerid')").mb-0
        SelectedProviderDropDownList(
          ref="dataAdd_providerID"
          size="sm"
          required
          type="array"
          :dirty="$v.dataAdd_providerID.$dirty"
          :error="$v.dataAdd_providerID.$error"
          v-model.trim.lazy="$v.dataAdd_providerID.$model"
          :disabled="loading"
          :options="selectedProviders"
        )
        ValidateResult(:value="$v.dataAdd_providerID" :name="$t('ui.providerid')")
      b-form-group(:label="$tc('ui.teams', 1)").mb-0
        DebounceInput(
          size="sm"
          required
          type="text"
          :dirty="$v.dataAdd_teamName.$dirty"
          :error="$v.dataAdd_teamName.$error"
          v-model.trim.lazy="$v.dataAdd_teamName.$model"
          :disabled="loading"
          :maxLength="$v.dataAdd_teamName.$params.maxLength.max"
        )
        ValidateResult(:value="$v.dataAdd_teamName" :name="$tc('ui.teams', 1)")
      div.row
        div.col-3
          b-form-group(:label="$t('ui.manual_link')" disabled).mb-0
            div.d-flex
              label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                input.switch-input(
                  type="checkbox"
                  required
                  v-model.trim.lazy="$v.dataAdd_manualLink.$model"
                  :disabled="loading"
                )
                span.switch-slider(:data-checked='on' :data-unchecked='off')
        div.col-3
          b-form-group(:label="$t('ui.mark_fetch')").mb-0
            div.d-flex
              label.switch.switch-label.switch-info.switch-sm.switch-xs.m-0
                input.switch-input(
                  type="checkbox"
                  required
                  v-model.trim.lazy="$v.dataAdd_markFetch.$model"
                  :disabled="loading"
                )
                span.switch-slider(:data-checked='on' :data-unchecked='off')
      div.row
        div.col
          b-alert.animated.flash(:show="!feedback.success" variant="bottom") {{ $t("error." + feedback.status) }}
    div(slot="modal-cancel")
      SubmitButton(:loading="loading" icon="fa fa-ban" :text="$t('ui.cancel')" isModal=true)
    div(slot="modal-ok")
      SubmitButton(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=true)
</template>

<script>
import { required, alphaNum, minLength, maxLength, url } from "vuelidate/lib/validators";
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import SelectedSportDropDownList from "@/library/SportList";
import SelectedProviderDropDownList from "@/library/ProviderList";
const greaterThanZero = (value) => value > 0;

export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    SelectedSportDropDownList,
    SelectedProviderDropDownList
  },
  data() {
    return {
      dataAdd_sportID: 0,
      dataAdd_providerID: "",
      dataAdd_teamName: "",
      dataAdd_manualLink: true,
      dataAdd_markFetch: false,
      loading: false,
      feedback: {
        success: true,
        status: "",
        team_id: "",
        epoch_time: ""
      },
      sportList: [],
      providerList: [],
      selectedProviders: []
    };
  },
  computed: {
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  validations: {
    dataAdd_sportID: {
      required,
      greaterThanZero
    },
    dataAdd_providerID: {
      required
    },
    dataAdd_teamName: {
      required,
      minLength: minLength(2),
      maxLength: maxLength(255),
    },
    dataAdd_manualLink: {
      required
    },
    dataAdd_markFetch: {
      required
    }
  },
  mounted: function() {
    this.getSportList();
    this.getProviderList();
  },
  methods: {
    getSportList() {
      let url = config.sportListUrl();

      var json = {
        action_by: this.$store.getters.username,
        session_token: this.$store.getters.sessionToken,
        page_id: config.accessRoles.team
      };

      this.$http.post(url, json).then(
        function(response) {
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.sportList = response.data.tbl_sport_list.filter(item => { return item.sport_id > 0; });
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getProviderList() {
      let url = config.providerListUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.provider
        };

        this.$http.post(url, json).then(
          function(response) {
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.providerList = response.data.tbl_provider_list;

                  for (var i = 0; i < this.providerList.length; i++) {
                    if (this.providerList[i].provider_disabled == false) {
                      this.selectedProviders.push({provider_id: this.providerList[i].provider_id, provider_name: this.providerList[i].provider_name});
                    }
                  }
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
    },
    done: function(evt) {
      evt.preventDefault();
      this.submit();
    },
    submit: function() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        let url = config.addTeamUrl();

        var json = {
          action_by: this.$store.getters.username,
          session_token: this.$store.getters.sessionToken,
          page_id: config.accessRoles.team,
          sport_id: this.dataAdd_sportID,
          provider_id: this.dataAdd_providerID,
          team_name: this.dataAdd_teamName,
          manual_link: this.dataAdd_manualLink,
          mark_fetch: this.dataAdd_markFetch
        };

        this.feedback.success = true;
        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.loading = false;
            // Success
            try {
              if (response) {
                if (typeof response.data.status == "string") {
                  this.feedback.success = response.data.status == "1";
                } else {
                  this.feedback.success = response.data.status == 1;
                }
                this.feedback.status = response.data.statusdesc;
                this.feedback.team_id = response.data.team_id;
                this.feedback.epoch_time = response.data.epoch_time;
                if (this.feedback.success == true) {
                  this.$emit("clicked", this.feedback.team_id, this.dataAdd_sportID, this.dataAdd_providerID, this.dataAdd_teamName, this.dataAdd_manualLink, this.feedback.epoch_time, this.dataAdd_markFetch);
                  this.$refs.addTeam.hide();
                } else {
                  this.$helpers.handleFeedback(this.feedback.status);
                  this.$emit("failed", "add_team", this.feedback.status);
                  this.$refs.addTeam.hide();
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        );
      }
    },
    reset: function() {
      this.dataAdd_sportID = 0;
      this.dataAdd_teamName = "";
      this.dataAdd_providerID = "";
      this.dataAdd_manualLink = true;
      this.dataAdd_markFetch = false;
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown: function() {
      this.$v.$reset();
      this.$refs.dataAdd_sportID.$el.focus();
    }
  }
};
</script>
